const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider || "rgba(0,0,0,0.1)"}`,
        borderRadius: "8px",
        padding: "1rem",
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
            boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
            transform: "translateY(-2px)",
        },
        "&:hover $deleteIcon": {
            opacity: 1,
        },
        "&:hover $editIcon": {
            opacity: 1,
        },
        "&:focus": {
            outline: "none",
            boxShadow: `0 0 0 3px ${theme.palette.primary.main}`,
            transform: "translateY(-2px)",
        },
        "&:focus $deleteIcon": {
            opacity: 1,
        },
        "&:focus-within $deleteIcon": {
            opacity: 1,
        },
    },
    colors: {
        backgroundColor: theme.palette.type === 'dark' ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)",
        height: "150px",
        width: "100%",
        borderRadius: "4px",
        overflow: "hidden",
        display: "grid",
        gridTemplateColumns: "repeat(5, 1fr)",
        gridTemplateRows: "repeat(4, 1fr)",
    },
    miniColor: {
        height: "100%",
        width: "100%",
        position: "relative",
    },
    title: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        margin: "0.75rem 0 0 0",
        color: theme.palette.text.primary,
        fontSize: "1rem",
        fontWeight: "500",
    },
    emoji: {
        marginLeft: "0.5rem",
        fontSize: "1.2rem",
    },
    actionsContainer: {
        position: "absolute",
        right: "0px",
        top: "0px",
        zIndex: 10,
        display: "flex",
    },
    deleteIcon: {
        color: "#ffffff",
        backgroundColor: "#eb3d30",
        width: "40px",
        height: "40px",
        padding: "8px",
        opacity: 0,
        transition: "all 0.2s ease-in-out",
        borderRadius: "0",
        borderBottomLeftRadius: "8px",
        "&:hover": {
            backgroundColor: "#d32f2f",
        },
    },
    editIcon: {
        color: "#ffffff",
        backgroundColor: "#2196f3",
        width: "40px",
        height: "40px",
        padding: "8px",
        opacity: 0,
        transition: "all 0.2s ease-in-out",
        borderRadius: "0",
        borderBottomLeftRadius: "8px",
        "&:hover": {
            backgroundColor: "#1976d2",
        },
    },
});

export default styles;
